import React from 'react';

import { useGetMediaView } from '@cobliteam/hooks/src/useCamera/useCameraMedia';

import { ShareIcon } from '@cobliteam/base-components';

import { Button, DropdownMenu } from '@cobliteam/ui/components';

import { ArrowBackRounded, ArrowForwardRounded } from '@material-ui/icons';

import useMediaStore from '../../../../store/zustand/useMediaStore';
import ShareMediaMenuItem from '../../../ShareMediaMenuItem';

export interface MediaDialogFooterProps {
  onNextMediaClick?: () => void;
  onPreviousMediaClick?: () => void;
  hasNextMedia?: boolean;
  hasPreviousMedia?: boolean;
  isNavigationButtonsDisabled?: boolean;
  isFetchingMediaRows?: boolean;
}

const MediaDialogFooter = ({
  onNextMediaClick,
  onPreviousMediaClick,
  isNavigationButtonsDisabled,
  hasPreviousMedia,
  hasNextMedia,
  isFetchingMediaRows,
}: MediaDialogFooterProps) => {
  const mediaViewId = useMediaStore((state) => state.mediaViewId);

  const { data: mediaView } = useGetMediaView(mediaViewId);

  const mediaData = mediaView?.mediaInfo;

  const handlePreviousMediaClick = () => {
    if (onPreviousMediaClick) {
      onPreviousMediaClick();
    }
  };

  const handleNextMediaClick = () => {
    if (onNextMediaClick) {
      onNextMediaClick();
    }
  };

  return (
    <div className='flex items-center justify-between p-5'>
      <DropdownMenu>
        <DropdownMenu.Trigger asChild>
          <Button
            variant='outlined'
            color='secondary'
            startIcon={<ShareIcon />}
          >
            Compartilhar vídeo
          </Button>
        </DropdownMenu.Trigger>
        <DropdownMenu.Content align='end'>
          {mediaData && <ShareMediaMenuItem media={mediaData} />}
        </DropdownMenu.Content>
      </DropdownMenu>
      {!isNavigationButtonsDisabled && (
        <div className='flex '>
          <Button
            variant='text'
            onClick={handlePreviousMediaClick}
            startIcon={<ArrowBackRounded />}
            disabled={!hasPreviousMedia}
            loading={isFetchingMediaRows || !mediaData}
            size='condensed'
          >
            Voltar
          </Button>
          <Button
            variant='contained'
            onClick={handleNextMediaClick}
            endIcon={<ArrowForwardRounded />}
            disabled={!hasNextMedia}
            loading={isFetchingMediaRows || !mediaData}
            size='condensed'
          >
            Próximo
          </Button>
        </div>
      )}
    </div>
  );
};

export default MediaDialogFooter;
